import { Tag } from 'antd';

import useSearchParam, { UseSearchParamProps } from '../hooks/useSearchParam';

interface RangeFilterTagProps extends Omit<UseSearchParamProps, 'array'> {
  nameMin: string;
  nameMax: string;
  label: string;
}

const RangeFilterTag = ({ nameMin, nameMax, label, ...props }: RangeFilterTagProps) => {
  const [min, setMin] = useSearchParam(nameMin, props);
  const [max, setMax] = useSearchParam(nameMax, props);

  if (!(min || max)) {
    return null;
  }

  return (
    <>
      {!!min && (
        <Tag closable onClose={() => setMin('')}>
          {label} acima de {min}
        </Tag>
      )}
      {!!max && (
        <Tag closable onClose={() => setMax('')}>
          {label} até {max}
        </Tag>
      )}
    </>
  );
};

export default RangeFilterTag;
